import React, { FC } from 'react';
import { Dialog } from '@mui/material';

import { useBoundStore } from 'store';
import { setSharedPopupOpen } from 'store/Layout';
import { ContentSort } from 'shared/components/form/ContentSort/ContentSort';
import { ContentForm } from 'shared/components/form/ContentForm/ContentForm';
import { ContentAttachments } from 'shared/components/form/ContentAttachments/ContentAttachments';
import { ContentHistory } from 'shared/components/layout/ContentHistory/ContentHistory';
import { GlobalSnackbar } from 'shared/components/layout/GlobalSnackbar/GlobalSnackbar';


export const SharedLayoutComponent: FC = () => {

  const { sharedPopupOpen, layoutTempState } = useBoundStore((state) => ({
    sharedPopupOpen: state.sharedPopupOpen,
    layoutTempState: state.layoutTempState,
  }));

  return (
    <div>
      <GlobalSnackbar />
      <Dialog open={sharedPopupOpen} onBackdropClick={() => setSharedPopupOpen(false)} maxWidth="lg">
        {(layoutTempState?.sortContent) && (
          <ContentSort {...layoutTempState}/>
        )}
        {(layoutTempState?.contentForm) && (
          <ContentForm {...layoutTempState}/>
        )}
        {(layoutTempState?.contentHistory) && (
          <ContentHistory {...layoutTempState}/>
        )}
        {(layoutTempState?.contentAttachments) && (
          <ContentAttachments {...layoutTempState}/>
        )}
      </Dialog>
    </div>
  );
};
